import React from 'react';
import SolutionDetail from '../components/SolutionDetail';
import StorageIcon from '@mui/icons-material/Storage';
import { Box, Button, Container, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const solutionData = {
  id: 'lims',
  name: 'Land Information Management System (LIMS)',
  icon: <StorageIcon sx={{ fontSize: 60 }} />,
  description: 'Comprehensive land data management and workflow automation solution',
  overview: `Our Land Information Management System (LIMS) is a sophisticated software solution designed to streamline land administration operations, enhance data management, and improve workflow efficiency. The system manages land records, property information, cadastral data, and land transactions while maintaining compliance with regulatory requirements. Our LIMS solution is customizable to meet specific land administration needs across various jurisdictions and organizations.`,
  features: [
    {
      title: 'Land Record Management',
      description: 'Complete tracking of land records, property information, and cadastral data',
    },
    {
      title: 'Workflow Automation',
      description: 'Automated land transaction processing, document management, and approval workflows',
    },
    {
      title: 'Data Security',
      description: 'Role-based access control and audit trail functionality for land records',
    },
    {
      title: 'Quality Control',
      description: 'Integrated data validation and compliance monitoring for land information',
    },
    {
      title: 'Reporting Tools',
      description: 'Customizable report templates for land records and property information',
    },
    {
      title: 'Integration Capabilities',
      description: 'Seamless integration with GIS systems and other land administration tools',
    },
  ],
  benefits: [
    'Improved land administration efficiency',
    'Enhanced data accuracy and security',
    'Reduced manual data entry',
    'Better regulatory compliance',
    'Real-time access to land records',
    'Streamlined land transaction processes',
  ],
};

const LIMS = () => {
  const navigate = useNavigate();

  return (
    <>
      <SolutionDetail solution={solutionData} />
      <Box sx={{ py: 8, backgroundColor: '#f8f9fa' }}>
        <Container>
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={8}>
              <Typography variant="h4" gutterBottom>
                Explore Our Products
              </Typography>
              <Typography variant="body1" paragraph>
                Discover our comprehensive suite of products designed to enhance your land information management capabilities. From desktop solutions to mobile applications, we have the tools you need to streamline your operations.
              </Typography>
            </Grid>
            <Grid item xs={12} md={4} sx={{ textAlign: { xs: 'center', md: 'right' } }}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={() => navigate('/products')}
                sx={{ 
                  px: 4,
                  py: 1.5,
                  fontSize: '1.1rem',
                  textTransform: 'none',
                  borderRadius: 2,
                }}
              >
                View Products
              </Button>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default LIMS; 